import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "calendar-page-content" }
const _hoisted_2 = { class: "calendar-page-list-view pr-4 w-full" }
const _hoisted_3 = { class: "fc-event-main-frame w-full" }
const _hoisted_4 = { class: "fc-event-title-container align-items-center" }
const _hoisted_5 = { class: "fc-event-title" }
const _hoisted_6 = { class: "flex grid w-full" }
const _hoisted_7 = { class: "flex col-6" }
const _hoisted_8 = { class: "title w-full flex" }
const _hoisted_9 = {
  key: 0,
  class: "col-6 flex p-1"
}

import { onMounted, ref, watch, computed } from 'vue';
import { useCalendarBulkAttendanceStore, useCalendarStore } from '@/store';
import FullCalendar from '@fullcalendar/vue3';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import CalendarBulkAttendance from './CalendarBulkAttendance.vue';
import { CALENDAR_COLOR, EMIT, PERMISSIONS } from '@/enum';
import { can, modifiedRRulePlugin, useDateTime, usePersonTypes } from '@/composables';
import Provider from '@/components/Provider';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarList',
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const calendar = ref();
const calendarStore = useCalendarStore();
const calendarBulkAttendanceStore = useCalendarBulkAttendanceStore();
const today = new Date();

__expose({ calendar });

onMounted(() => {
  setCalendarEvents();
});

const setCalendarEvents = () => {
  calendarOptions.value.events = calendarStore.events ? calendarStore.events : [];
};

watch(() => calendarStore.events, setCalendarEvents);

const calendarOptions = ref<CalendarOptions>({
  plugins: [listPlugin, interactionPlugin, modifiedRRulePlugin],
  initialView: 'listWeek',
  headerToolbar: false,
  listDayFormat: { day: 'numeric' },
  dayHeaderContent: (arg) =>
    calendarBulkAttendanceStore.defineBulkAttendance(arg, can([PERMISSIONS.THERAPY_RESULTS_BULK_UPDATE])),
  eventClassNames: (arg) => calendarStore.defineEventsClassNames(arg),
  listDaySideFormat: false,
  stickyHeaderDates: false,
  weekends: true,
  nowIndicator: true,
  height: '100%',
  eventBackgroundColor: CALENDAR_COLOR.EVENT_BACKGROUND_COLOR,
  eventBorderColor: CALENDAR_COLOR.EVENT_BORDER_COLOR,
  eventTextColor: CALENDAR_COLOR.EVENT_TEXT_COLOR,
  eventMinHeight: 24,
  events: [],

  eventClick: (info: EventClickArg) => {
    const isDocumented = info.event._def.extendedProps.eventStatus === 'documented';
    const isInPast = (info.event.start as Date) < new Date();
    const isCaseloadManagement = calendarStore.isCaseloadManagement(info.event._def.extendedProps.eventType);
    const showDocumentEvent = isDocumented || isInPast;
    const isCaseloadAndInCurrentMonth =
      isCaseloadManagement && useDateTime().isSameMonthAndYear(info.event.start as Date);

    if (showDocumentEvent && !isCaseloadAndInCurrentMonth) {
      emit(EMIT.DOCUMENT_EVENT, info);
    } else {
      emit(EMIT.EDIT_EVENT, info);
    }
  },
  viewDidMount: () => emit(EMIT.MOUNTED, 'list'),

  eventDidMount: (info) => {
    const eventTimeTd = info.el.getElementsByClassName('fc-list-event-time')[0];

    const start = useDateTime().formatTimeByTimezone(
      info.event.start as Date,
      info.event.extendedProps.hostTimezoneName,
    );

    const end = useDateTime().formatTimeByTimezone(info.event.end as Date, info.event.extendedProps.hostTimezoneName);

    if (eventTimeTd) {
      //need to catch it on the next cycle because it still loads the orig text
      setTimeout(() => {
        eventTimeTd.innerHTML = `${start} - ${end}  ${info.event.extendedProps.hostTimezone}`;
      }, 0);
    }
  },
});

const isClinician = computed(() => usePersonTypes.isClinician());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(can)([_unref(PERMISSIONS).THERAPY_RESULTS_BULK_UPDATE]) && _unref(calendarBulkAttendanceStore).displayBulkAttendance)
        ? (_openBlock(), _createBlock(CalendarBulkAttendance, {
            key: 0,
            onCancel: _unref(calendarBulkAttendanceStore).onBulkAttendanceCancel
          }, null, 8, ["onCancel"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(FullCalendar), {
        ref_key: "calendar",
        ref: calendar,
        options: calendarOptions.value,
        class: _normalizeClass('today-is-' + _unref(today).toLocaleDateString('en-us', { weekday: 'long' }))
      }, {
        eventContent: _withCtx((arg) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(arg.event.title), 1)
                  ]),
                  (!isClinician.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(Provider), {
                          "discipline-code": arg.event.extendedProps.discipline_code,
                          "service-provider-name": arg.event.extendedProps.classroom.service_provider_name
                        }, null, 8, ["discipline-code", "service-provider-name"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["options", "class"])
    ])
  ]))
}
}

})